import React, { useEffect, useState } from "react";
import "./faq.css";

const faqData = [
    {
        key: "one",
        he: "איזה סוגי פרגולות אתם מציעים?",
        heAnswer:
            "אנו מציעים פרגולות אלומיניום, פרגולות עץ, פרגולות תלויות ופרגולות חשמליות עם אפשרות לשליטה מרחוק. כל הפרגולות מיוצרות מחומרים איכותיים ועמידים בתנאי מזג האוויר בישראל.",
    },
    {
        key: "two",
        he: "האם אתם מספקים שירות התקנה?",
        heAnswer:
            "כן! אנו מספקים שירות התקנה מקצועי על ידי צוות מיומן. אנו דואגים לכל תהליך ההתקנה – מהמדידות ועד ההרכבה הסופית, כדי להבטיח תוצאה מושלמת.",
    },
    {
        key: "three",
        he: "איזה סוגי גדרות אתם מתקינים?",
        heAnswer:
            "אנו מציעים מגוון גדרות: גדרות עץ טבעי, גדרות אלומיניום מודרניות, גדרות במבוק דקורטיביות וגדרות PVC עמידות. ניתן להתאים את העיצוב לפי דרישות הלקוח.",
    },
    {
        key: "four",
        he: "האם ניתן לקבל הצעת מחיר לפני ההתקנה?",
        heAnswer:
            "בוודאי! אנו מציעים ייעוץ ראשוני חינם והצעת מחיר בהתאמה אישית לאחר בדיקה של השטח והצרכים שלכם.",
    },
    {
        key: "five",
        he: "מהם היתרונות של דק עץ לעומת דק סינטטי?",
        heAnswer:
            "דק עץ מעניק מראה טבעי וחמים, אך דורש תחזוקה תקופתית. דק סינטטי, לעומת זאת, עמיד יותר לתנאי מזג האוויר, אינו דורש צביעה או טיפול מיוחד",
    },
];

const Faq = () => {
    const [openFaqs, setOpenFaqs] = useState({});

    const handleToggleFaq = (key) => {
        setOpenFaqs((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    return (
        <div id="faq">
            <h1 data-aos="fade-up">
                שאלות<span>?</span>
            </h1>
            <ul data-aos="fade-up">
                {faqData.map(({ key, he, heAnswer }) => (
                    <li key={key} className={openFaqs[key] ? "expanded" : ""}>
                        <div>
                            <h2 style={{ direction: "rtl" }}>{he}</h2>
                            <button aria-label="Toggle show answer">
                                <label className="hamburger">
                                    <input
                                        onClick={() => handleToggleFaq(key)}
                                        type="checkbox"
                                    />
                                    <svg viewBox="0 0 32 32">
                                        <path
                                            className="line line-top-bottom"
                                            d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                                        ></path>
                                        <path
                                            className="line"
                                            d="M7 16 27 16"
                                        ></path>
                                    </svg>
                                </label>
                            </button>
                        </div>
                        <p style={{ direction: "rtl" }}>{heAnswer}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Faq;
